import { v4 as UUID } from 'uuid'
import { getSubstringSpaceReplaced } from 'src/core/helpers'
import { CreateBrokerageProjectPayload } from 'src/core/models'

export const getInactiveProjectTransformed = (
  data: CreateBrokerageProjectPayload, isVintage: boolean
) => {

  return {
    name: data.name,
    co2_balance: isVintage ? 0 : data.volume_credits,
    price: isVintage ? 0 : data.price,
    vintage_items: !isVintage ? [] : [{
      year: +data.vintageYear,
      price: +data.price,
      stock: data.volume_credits
    }],
    sellerEmail: data.email,
    is_active: false,
    is_visible_in_climatetrade: false,
    is_vintage: isVintage,
    description: 'Empty Description',
    code: `${getSubstringSpaceReplaced(data?.name).toUpperCase()}-${UUID()}`,
    cover: null
  }
}
